// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productInformationStyles } from "@west/Overrides/Widgets/ProductList/ProductListProductInformation";
import { ellipsis } from "@west/XDL/Utilities";
import { css } from "styled-components";

productInformationStyles.container = {
    gap: 8,
};

productInformationStyles.attributes = {};

productInformationStyles.partNumbersStyles = {};

productInformationStyles.compareGridItem = {
    width: 12,
    css: css`
        gap: 32px;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 12px;
    `,
};

productInformationStyles.brandStyles = {
    nameLink: {
        typographyProps: {
            lineHeight: "16px",
        },
    },
    nameText: {
        lineHeight: "16px",
    },
};

productInformationStyles.descriptionGridItem = {
    width: 12,
    css: css`
        ${ellipsis(2)};
    `,
};

productInformationStyles.descriptionStyles = {
    productDetailLink: {
        typographyProps: {
            size: 14,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 16px;
            `,
        },
    },
    productDetailDescription: {
        size: 14,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 16px;
        `,
    },
};
